import { Typography } from "antd";
import { Link } from "react-router-dom";
import { useTranslation } from "../../i18n";

const { Title, Paragraph } = Typography;

function ErrorPanel({ message }) {
    const { t } = useTranslation();

    return (
        <div className="delivery-card delivery-status">
            <Title level={3}>{t("delivery.error.title")}</Title>
            <Paragraph className="delivery-status__text">
                {message || t("delivery.error.subtitle")}
            </Paragraph>
            <Paragraph>
                <Link to="/">{t("common.backHome")}</Link>
            </Paragraph>
        </div>
    );
}

export default ErrorPanel;
